import React from "react";
import { XIcon, CheckIcon, ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { OfferCountdown } from "../OfferCountdown";
const fromItems = ["Unorganized clinical findings.", "Disconnected growth concepts.", "Uncertainty about treatment indications.", "Scattered planning references."];
const toItems = ["Structured assessment.", "Clearer developmental understanding.", "Organized decision pathways.", "Defined educational planning steps.", "Reusable case-review resources."];
export function FinalCtaSection() {
  return <section className="w-full bg-wine px-4 py-16 sm:px-5 sm:py-24" data-id="element-175" data-mp="319h3x867x1e7">
      <div className="mx-auto max-w-4xl" data-id="element-176" data-mp="31as7p7zny95b">
        <p className="text-center text-sm font-bold uppercase tracking-widest text-white/80" data-id="element-177" data-mp="2w9l0ba1fnbz6">
          Your next growing-patient case deserves a structured assessment
        </p>
        <h2 className="mt-3 text-center font-serif text-[28px] font-black leading-tight text-white sm:text-4xl" data-id="element-178" data-mp="368ajr78z94hj">
          Stop Jumping From Clinical Findings to Treatment Ideas Without a Clear Framework.
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-center text-lg text-white/85" data-id="element-179" data-mp="261eflusz3f2n">
          Early orthodontic decisions require an understanding of growth, development, treatment indications,
          limitations, and monitoring. With Interceptive Orthodontics Blueprint™, you’ll have an organized
          educational collection to study these decisions through a structured framework.
        </p>

        <div className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-180" data-mp="2p08sszcsg7gp">
          <div className="rounded-3xl bg-wine-deep p-6" data-id="element-181" data-mp="2oynzfd27mukf">
            <p className="text-sm font-extrabold uppercase tracking-widest text-white/70" data-id="element-182" data-mp="2tt1x5m4chds9">From</p>
            <ul className="mt-3 space-y-2.5" data-id="element-183" data-mp="2ypin8lv3u27z">
              {fromItems.map(f => <li key={f} className="flex gap-2.5 text-white/85" data-id="element-184" data-mp="33qzm6bu13elx">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-white/60" aria-hidden="true" data-id="element-185" data-mp="38orntxkh6f3b" />
                  {f}
                </li>)}
            </ul>
          </div>
          <div className="rounded-3xl bg-white p-6" data-id="element-186" data-mp="2iyjc1yalc9cd">
            <p className="text-sm font-extrabold uppercase tracking-widest text-cta" data-id="element-187" data-mp="2e33vgyl77zc9">To</p>
            <ul className="mt-3 space-y-2.5" data-id="element-188" data-mp="2srqkxt4ji7h7">
              {toItems.map(t => <li key={t} className="flex gap-2.5 font-semibold text-navy" data-id="element-189" data-mp="2nzp21ocv9ii7">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-190" data-mp="31r3lfwaorlps" />
                  {t}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-xl rounded-3xl bg-white p-6 text-center shadow-2xl sm:p-8" data-id="element-191" data-mp="3bq2wflixbtfy">
          <p className="font-serif text-xl font-bold text-navy sm:text-2xl" data-id="element-192" data-mp="36q6rnk2ejxzc">
            Get the Complete Interceptive Orthodontics Blueprint™
          </p>
          <p className="mt-2 text-sm font-bold uppercase tracking-wide text-wine" data-id="element-193" data-mp="1hdd3p74akqa5">
            6 Specialized Volumes + 5 Professional Bonuses
          </p>
          <p className="mt-4 text-muted" data-id="element-194" data-mp="3o0tzdhr4iqfy">
            Total reference value: <s className="font-bold" data-id="element-195" data-mp="3sylyavq6rctn">$244 USD</s>
          </p>
          <p className="mt-1 text-sm font-bold uppercase tracking-wide text-navy" data-id="element-196" data-mp="3sy2jhnvu14ju">Today only</p>
          <p className="font-serif text-7xl font-black leading-none text-cta" data-id="element-197" data-mp="3e9piudlsuxj0">$27</p>
          <p className="mt-1 font-bold text-navy" data-id="element-198" data-mp="3j7hkhzc8xy0e">USD · One-Time Payment</p>

          <div className="mt-6" data-id="element-199" data-mp="3591bu2utpxfm">
            <CtaButton label="Yes! I want instant access" data-id="element-200" data-mp="357zslb3nm4mt" />
          </div>
          <OfferCountdown data-id="element-201" data-mp="39bnzdrkgow70" />
          <p className="mt-5 text-sm text-muted" data-id="element-202" data-mp="39c7fr3ugrcix">
            Immediate Digital Access · Lifetime Access · Price automatically converted to your local currency
          </p>
          <p className="mt-2 flex items-center justify-center gap-1.5 text-sm font-semibold text-cta" data-id="element-203" data-mp="30azm4z2w6zv6">
            <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-204" data-mp="tl1oswrwzcl8" />
            7-day refund guarantee
          </p>
        </div>
      </div>
    </section>;
}